function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
(function(s,H){function n(s,H,t,C,i){return m(H- -0x265,t);}function Q(s,H,t,C,i){return m(H- -0x74,C);}function N(s,H,t,C,i){return m(s-0x21,C);}var t=s();function v(s,H,t,C,i){return m(s-0x374,t);}function W(s,H,t,C,i){return m(s-0x19d,C);}while(!![]){try{var C=-parseInt(Q(0x1f8,0x213,0x25d,'n^1B',0x280))/(-0x57*-0x1a+-0x1*-0x23f2+-0x2cc7)*(parseInt(Q(0x182,0x1bd,0x12d,'Xjjs',0x179))/(0x1225*0x1+0x553+-0x1ad*0xe))+-parseInt(N(0x2a4,0x33d,0x234,'Yehh',0x2ff))/(-0x5cf+-0x7d*0x7+0x37*0x2b)+-parseInt(n(-0xc1,-0xab,'RqLR',-0x128,-0x92))/(0x2068+-0x20e7*0x1+0x83*0x1)*(parseInt(Q(0x176,0x141,0x115,'dKC!',0xf0))/(-0x1*0x6ef+-0x1d4b+0x243f))+-parseInt(Q(0xf1,0x16b,0xd9,'70b3',0x1f3))/(-0x32*-0x18+0x123*-0x22+0x21fc)+parseInt(n(-0xcd,-0xbf,'YJw7',-0x135,-0x45))/(-0x24de+-0x21ec+0x46d1*0x1)+-parseInt(n(-0x1f,-0x66,'n^1B',-0x49,-0x49))/(-0x136d+-0x1f*-0x63+0x778)*(parseInt(v(0x547,0x5b1,'XD*)',0x4ed,0x55c))/(0x26a*-0x4+0x27*-0x92+0x1fef))+parseInt(W(0x3f3,0x43e,0x402,'EHRq',0x46b))/(-0x3*0x26+0x72c+-0x6b0)*(parseInt(N(0x1d8,0x195,0x151,'$f2y',0x241))/(-0x18cd+-0x1d*-0x13+0x16b1));if(C===H)break;else t['push'](t['shift']());}catch(i){t['push'](t['shift']());}}}(G,-0xa10ab*0x1+0x12d69*0xb+0x7a609),!function(o,B,x){var q={'GcHaX':U(0x668,0x66d,0x606,0x65f,'OL(7')+p('EHRq',0x34a,0x2e1,0x363,0x30b)+'0','JxkeS':function(j,R){return j===R;},'EezPh':p('uZ3Y',0x3d4,0x309,0x357,0x399),'UerOh':p('Cw&J',0x33f,0x3d2,0x3c7,0x33f),'CUTCX':function(j,R){return j!==R;},'WlVYE':e('(Bse',0xe9,0x87,0x8d,-0x4),'OmLba':function(j,R){return j===R;},'WDHJV':k(0x270,0x313,0x2e4,'rn37',0x258),'ekTkS':p('ivtK',0x32d,0x399,0x365,0x2fe),'CByPp':k(0x331,0x3a9,0x37b,'d9N7',0x3e2),'pVNjM':e('cD#Q',0xfe,0x1a4,0x17b,0x134),'nfXah':p('4XkX',0x35f,0x453,0x391,0x3b8)+p('OL(7',0x2e3,0x38b,0x305,0x329)+'+$','VkGtH':U(0x521,0x5c5,0x5c1,0x547,'ow)4'),'BIKms':s0('OL(7',-0x44,0x21,0xaf,-0x36)+e('6DJC',0x15a,0x191,0x18b,0x145)+k(0x3b1,0x33c,0x3cd,'gr!d',0x444)+p('Cw&J',0x316,0x2fc,0x2ec,0x29f)+e('Xjjs',0x14c,0x132,0x1b7,0x159)+U(0x558,0x545,0x53f,0x53c,'F6WU')+U(0x60e,0x5b1,0x6bf,0x625,'XD*)')+p('OjR]',0x3c3,0x3f0,0x3a6,0x3c4)+p('EHRq',0x347,0x25a,0x264,0x2e5),'iXLbP':p('gr!d',0x2f8,0x223,0x253,0x2b7)+'t','RFcCN':U(0x664,0x6a0,0x5b0,0x609,'1a)Q'),'TEcIE':p('sGv1',0x221,0x2c2,0x264,0x2ab),'KuQqi':k(0x337,0x410,0x3ab,'Xjjs',0x3d4),'NzMcO':s0('$f2y',0x77,0x1,0x59,0x51),'xQWOg':U(0x5d9,0x667,0x6bf,0x638,'[%hZ')+p('Ymz1',0x315,0x362,0x32b,0x336),'xDfVO':function(j,R){return j(R);},'IGkFk':function(j,R){return j+R;},'glkjl':e('Yehh',0x122,0x94,0xca,0x14f)+e('T6s2',0x107,0x133,0x192,0x195)+s0('gr!d',-0x15,-0x22,-0x4e,-0x78)+U(0x57c,0x610,0x5fd,0x603,'kdt0'),'WWklo':s0('OQdG',0xe,0x42,-0x28,-0x21)+p('1a)Q',0x331,0x39e,0x38a,0x395)+U(0x623,0x604,0x591,0x5d6,'6DJC')+U(0x6b2,0x631,0x702,0x665,'i9q5')+s0('YJw7',0xa4,0x1f,-0x7e,0x72)+k(0x3f8,0x3b7,0x3b7,'Cw&J',0x384)+'\x20)','LUqgp':function(j){return j();},'IWlJY':function(j,R){return j<R;},'nijbh':k(0x480,0x445,0x3ea,'Ymz1',0x445)+U(0x590,0x5cb,0x4eb,0x559,'41S$')+'1','WpBhn':U(0x61c,0x629,0x5e4,0x58c,'cD#Q'),'gLnIQ':U(0x62e,0x5d4,0x528,0x5bf,'JPIv'),'HtBnS':p('c7Ci',0x23a,0x32d,0x309,0x2c7),'fSZpL':k(0x3cd,0x3f1,0x3f0,'JPIv',0x403),'mBLQj':s0('i9q5',-0x14,-0x49,0x36,-0x4c)+p('XTOP',0x30b,0x34e,0x3aa,0x378),'RSbDL':s0('n^1B',0xe,-0x10,0x16,-0x99),'EEoil':e('oB6K',0xbc,0x116,0xab,0x12),'TPDPg':function(j){return j();},'sGLxE':function(j,R){return j===R;},'PAmbQ':s0('4XkX',0x122,0x92,0xc9,-0xb),'roGqY':function(j,R){return j+R;},'WaPJD':function(j,R){return j!==R;},'kVjnK':s0('ow)4',0x59,0x37,-0x53,-0x7),'aghGB':U(0x5a3,0x644,0x618,0x63f,'Cw&J'),'kapBP':p('70b3',0x2f1,0x279,0x2c8,0x309)+k(0x31f,0x39d,0x364,'c7Ci',0x3e7)+'3','MaMyV':function(j,R,b){return j(R,b);},'zuEVb':function(j,R,b){return j(R,b);},'BzpWW':U(0x5e4,0x5c8,0x66d,0x600,'OjR]')+k(0x2f3,0x385,0x37e,'$f2y',0x3bf)+e('T6s2',0x13b,0x13b,0x171,0x137)+U(0x510,0x4b3,0x53b,0x53a,'*3HG')+e('d9N7',0xc3,0xf2,0x15d,0x19b)+e('$f2y',0x193,0x170,0x155,0x141)+s0('&bC%',-0xd2,-0x5c,-0xd9,-0x94)+s0('d9N7',-0x69,0xc,-0x66,0xaa)+s0('oB6K',0x15,-0x44,-0xdb,-0x55)+U(0x607,0x6c2,0x6b6,0x65c,'pMKL')+s0('Yehh',0x1f,0x68,0x101,0xfd)+k(0x348,0x2d1,0x2f6,'BU41',0x27b)+'s'},f=(function(){function s6(s,H,t,C,i){return U(s-0x1b1,H-0x102,t-0x1e9,i- -0x284,C);}function s2(s,H,t,C,i){return U(s-0x19c,H-0x5e,t-0xa5,s- -0x1dc,i);}var j={'hXtpc':function(b,w){function s1(s,H,t,C,i){return m(t- -0x263,H);}return q[s1(-0x3f,'T6s2',-0x46,-0x47,-0xda)](b,w);},'LOyps':q[s2(0x43f,0x3e8,0x4d0,0x43a,'qKVp')],'WkVWf':function(b,w){function s3(s,H,t,C,i){return s2(t-0x45,H-0x16c,t-0x63,C-0x1e8,i);}return q[s3(0x401,0x4a9,0x47a,0x4ad,'ivtK')](b,w);},'AtoIA':q[s4(0x4cc,'rn37',0x547,0x556,0x567)]};function s7(s,H,t,C,i){return U(s-0x3,H-0x60,t-0xfc,t- -0x198,s);}function s5(s,H,t,C,i){return e(H,H-0x14e,t-0x9d,i-0x44,i-0xbc);}function s4(s,H,t,C,i){return s0(H,H-0x48,t-0x507,C-0xe2,i-0x1a0);}if(q[s2(0x3ab,0x374,0x390,0x3f6,'RqLR')](q[s6(0x40c,0x367,0x434,'Xjjs',0x3e0)],q[s7('XD*)',0x513,0x4d3,0x500,0x542)])){var F=q[s5(0x173,'EHRq',0x91,0x189,0xf8)][s5(0x182,'Ymz1',0x1be,0x19f,0x1cd)]('|'),Z=-0x2689+0x1*-0x84a+-0x1*-0x2ed3;while(!![]){switch(F[Z++]){case'0':R[E]=P;continue;case'1':var E=f[u];continue;case'2':P[s4(0x480,'41S$',0x51d,0x540,0x5ac)+s5(0x230,'AQaU',0x1a9,0x1ea,0x1ad)]=S[s7('$f2y',0x325,0x3c0,0x322,0x3aa)](j);continue;case'3':P[s5(0x17c,'$f2y',0xb8,0x17d,0xe6)+s5(0x11c,'jvpD',0x124,0x16d,0x118)]=Y[s4(0x461,'1a)Q',0x4fe,0x577,0x56a)+s5(0x156,'OL(7',0x17e,0x133,0x1bc)][s7('uZ3Y',0x332,0x3a0,0x3b7,0x334)](Y);continue;case'4':var P=x[s2(0x433,0x416,0x3aa,0x397,'ow)4')+s6(0x415,0x37e,0x2fb,'[%hZ',0x384)+'r'][s5(0x125,'d9N7',0x1e2,0x165,0x18b)+s5(0x82,'YJw7',0x165,0xda,0x11e)][s5(0x1c3,'kdt0',0x191,0x165,0x162)](q);continue;case'5':var Y=V[E]||P;continue;}break;}}else{var R=!![];return function(w,L){function so(s,H,t,C,i){return s6(s-0x1f3,H-0x12,t-0x47,C,H- -0x3a3);}function ss(s,H,t,C,i){return s5(s-0x16e,C,t-0x1bc,C-0x49,t-0x14d);}function s8(s,H,t,C,i){return s7(t,H-0x169,C- -0x32d,C-0x135,i-0x1f3);}function s9(s,H,t,C,i){return s2(i- -0x326,H-0x148,t-0x1b,C-0xc4,H);}if(q[s8(0x1de,0x1cd,'YpvL',0x163,0x1cf)](q[s9(0x1c3,'XD*)',0x1d2,0xd1,0x145)],q[s9(0xaa,'ow)4',0x13b,0x15d,0xfc)])){var F=R?function(){function st(s,H,t,C,i){return s9(s-0xc0,i,t-0xb0,C-0x19d,H-0x368);}function sH(s,H,t,C,i){return ss(s-0x113,H-0x16c,C-0x20c,t,i-0x1c9);}function si(s,H,t,C,i){return ss(s-0x3b,H-0x8b,C- -0x1e2,H,i-0x1f0);}function sC(s,H,t,C,i){return ss(s-0x16a,H-0x1ed,H- -0x13a,C,i-0x194);}function sg(s,H,t,C,i){return ss(s-0x199,H-0x9d,i- -0x160,H,i-0xef);}if(j[sH(0x3e9,0x39d,'dKC!',0x436,0x498)](j[st(0x3ca,0x446,0x425,0x43c,'XD*)')],j[sH(0x490,0x46e,'YpvL',0x42b,0x493)])){if(L){if(j[si(0x1a9,'ow)4',0xce,0x144,0x1a9)](j[si(0xe4,'AQaU',0x13c,0x125,0x14f)],j[sH(0x4cc,0x513,'(Uj[',0x481,0x447)])){var P=o?function(){function sG(s,H,t,C,i){return sH(s-0x1da,H-0x4e,H,s- -0x348,i-0x1ef);}if(P){var Y=b[sG(0x14a,'ow)4',0x13e,0x185,0xce)](w,arguments);return L=null,Y;}}:function(){};return u=![],P;}else{var Z=L[sC(0x19d,0x113,0xca,'[%hZ',0x1a2)](w,arguments);return L=null,Z;}}}else{var Y=o?function(){function sm(s,H,t,C,i){return sg(s-0xad,t,t-0xdc,C-0x93,C- -0x285);}if(Y){var J=b[sm(-0x71,-0x117,'1a)Q',-0xa2,-0x9b)](w,arguments);return L=null,J;}}:function(){};return u=![],Y;}}:function(){};return R=![],F;}else{if(i){var E=x[ss(0x20b,0x253,0x258,'XD*)',0x1fe)](q,arguments);return f=null,E;}}};}}());function e(s,H,t,C,i){return m(C- -0x10e,s);}var u=q[e('luji',0xf6,0xd9,0xb6,0xa3)](f,this,function(){function su(s,H,t,C,i){return U(s-0x1e9,H-0x11a,t-0x1cf,t- -0x613,H);}function sB(s,H,t,C,i){return k(s-0x0,H-0x10f,t- -0x187,C,i-0xb5);}function sq(s,H,t,C,i){return s0(H,H-0x16a,t- -0x42,C-0x1d1,i-0xca);}function sx(s,H,t,C,i){return p(H,H-0x15a,t-0x1ab,C-0x28,C- -0x344);}function sf(s,H,t,C,i){return e(i,H-0x1eb,t-0xf4,C-0x33,i-0xed);}if(q[sB(0x117,0x1a4,0x154,'jvpD',0x130)](q[sx(0x2,'Yehh',-0xaa,-0x6d,-0x7b)],q[sB(0x2b0,0x2ba,0x276,'n^1B',0x224)]))x=C;else return u[sq(0xcb,'OL(7',0x5e,0x2f,0xe5)+sq(-0x38,'41S$',-0x45,-0x6d,-0xa8)]()[sx(0x39,'luji',-0x61,-0x48,0x4f)+'h'](q[sx(-0x68,'Xjjs',-0x83,-0x9c,-0xdf)])[su(-0x26,'kdt0',0x2d,0x1,-0xe)+su(-0x47,'Cw&J',-0xa4,-0xeb,-0xec)]()[sq(-0x82,'d9N7',-0x8d,-0xdf,0xd)+su(-0x40,'d9N7',-0xd1,-0x15e,-0x12d)+'r'](u)[sB(0x1cd,0x21b,0x1f3,'](y^',0x211)+'h'](q[sx(-0x7e,'cD#Q',0x1,-0x26,-0x9f)]);});q[k(0x292,0x2d8,0x32a,'cD#Q',0x319)](u);var V=(function(){function sR(s,H,t,C,i){return U(s-0x1b8,H-0x1a6,t-0x1af,H- -0x5dc,s);}function sV(s,H,t,C,i){return U(s-0x1cb,H-0x19e,t-0x1ea,H- -0x24c,t);}function sS(s,H,t,C,i){return s0(s,H-0x1b2,i- -0x118,C-0x1a5,i-0x165);}function sb(s,H,t,C,i){return p(t,H-0x1a0,t-0x140,C-0x92,s- -0x43d);}function sw(s,H,t,C,i){return U(s-0xc9,H-0x143,t-0x148,t- -0x168,H);}var j={'zgKxb':q[sV(0x3b0,0x3e8,'70b3',0x3e7,0x35c)],'PGIjk':q[sS('jvpD',-0x77,-0xc0,-0x106,-0xc1)],'xYwUi':function(b,w){function sj(s,H,t,C,i){return sV(s-0x163,C- -0x43e,s,C-0xd3,i-0x11b);}return q[sj('i9q5',-0xe8,-0x39,-0x7e,-0xfb)](b,w);},'DtpWZ':q[sR('oB6K',-0x9b,-0x129,-0xa4,-0x20)],'lkPEl':q[sV(0x3bf,0x3f1,'cD#Q',0x397,0x43d)]};if(q[sR('1a)Q',0x7b,0xcc,0x100,0x90)](q[sS('4XkX',-0x173,-0x183,-0x17b,-0xf6)],q[sw(0x4b0,'Yehh',0x488,0x3ec,0x42f)]))(x=q[sV(0x31e,0x396,'d9N7',0x395,0x3b0)+sw(0x492,'OL(7',0x44d,0x4a5,0x441)+sw(0x478,'JPIv',0x4ce,0x48b,0x4ec)](f))[sS('Yehh',-0x10b,-0x1ea,-0x11b,-0x177)]=!(-0x176f+-0x39*0x33+0x22ca),u[sw(0x3f1,'41S$',0x439,0x409,0x49f)]=j[sb(-0xed,-0xe4,'ivtK',-0x11e,-0x162)],(V=S[sb(-0xa0,-0x1e,'i9q5',-0xc,-0x11a)+sw(0x445,'sGv1',0x4a6,0x539,0x486)+sb(-0x149,-0x1a9,'F6WU',-0x1d5,-0x1b5)+sw(0x4fd,'(Bse',0x492,0x503,0x4cf)](j[sb(-0x11d,-0x126,'[%hZ',-0x16a,-0xfc)])[-0x70b+0x43*0x16+0x149])[sV(0x2b6,0x34f,'OjR]',0x375,0x3a9)+sS('$f2y',-0x59,-0x60,-0x13f,-0xa7)][sw(0x510,'cD#Q',0x4c7,0x463,0x489)+sw(0x44f,'T6s2',0x459,0x42d,0x4f1)+'re'](j,R[sw(0x586,'(Uj[',0x4f0,0x4fe,0x4e8)+sb(-0xab,-0x74,'ivtK',-0xf6,-0x75)+'g']);else{var R=!![];return function(w,L){function sl(s,H,t,C,i){return sR(s,t-0x313,t-0x57,C-0x145,i-0x26);}function sZ(s,H,t,C,i){return sw(s-0x63,C,H- -0x28c,C-0x102,i-0x157);}function sF(s,H,t,C,i){return sV(s-0x158,C- -0xc7,t,C-0x4c,i-0x1ec);}function sL(s,H,t,C,i){return sb(H- -0x20,H-0x1b2,s,C-0x1f1,i-0xc3);}if(q[sL('OjR]',-0x135,-0x182,-0xba,-0x1a3)](q[sL('pMKL',-0xff,-0x108,-0x10d,-0x155)],q[sF(0x247,0x1a0,'YJ[F',0x238,0x251)])){var F=R?function(){function sE(s,H,t,C,i){return sL(C,s-0x618,t-0x5b,C-0x120,i-0x82);}function sJ(s,H,t,C,i){return sZ(s-0xac,H- -0x37e,t-0x11b,t,i-0x12e);}function sh(s,H,t,C,i){return sZ(s-0x162,C- -0xac,t-0x18c,H,i-0x15b);}function sY(s,H,t,C,i){return sL(C,H-0x2da,t-0xe0,C-0x155,i-0x147);}function sP(s,H,t,C,i){return sF(s-0x1e3,H-0x129,C,i- -0x3c0,i-0x9b);}if(j[sE(0x4e0,0x56d,0x55b,'6DJC',0x4f5)](j[sP(-0x53,-0x101,0x16,'&bC%',-0x6b)],j[sY(0xf7,0x135,0x110,'T6s2',0xb9)])){if(L){if(j[sJ(-0x136,-0x1a7,'OQdG',-0x235,-0x15c)](j[sh(0x155,'gkxX',0x163,0xdd,0x158)],j[sh(0xfd,'c7Ci',0xfe,0xda,0x10b)])){var Z=L[sP(-0x158,-0xbe,-0x15c,'70b3',-0xe8)](w,arguments);return L=null,Z;}else{var P=C[sP(-0xd8,-0x105,-0x7b,'sGv1',-0xbd)](i,arguments);return g=null,P;}}}else{var Y=C[sY(0x1a7,0x1c7,0x232,'$f2y',0x1bd)](i,arguments);return g=null,Y;}}:function(){};return R=![],F;}else{if(i){var E=x[sZ(0x142,0x190,0x166,'*3HG',0x160)](q,arguments);return f=null,E;}}};}}()),S=q[e('Ymz1',0xd0,0xac,0x9f,0x16)](V,this,function(){var j={'drDrd':function(h,l){function sy(s,H,t,C,i){return m(i- -0x22f,t);}return q[sy(0x58,-0x24,'i9q5',0x5b,0x3a)](h,l);},'aPPde':function(h,l){function sz(s,H,t,C,i){return m(t- -0x377,C);}return q[sz(-0x182,-0x111,-0x170,'Yehh',-0x181)](h,l);},'Ombxd':function(h,l){function sO(s,H,t,C,i){return m(C-0x4c,i);}return q[sO(0x2ae,0x29e,0x379,0x2ed,'(Bse')](h,l);},'WNaPH':q[sd(0xa1,0x8f,0xd4,0xa2,'ow)4')],'SBxpx':q[sd(0x137,0x8b,0xcf,0x9f,'n^1B')],'psIow':function(h){function sa(s,H,t,C,i){return sd(s-0xbc,H-0x1c4,t-0x13e,H-0x469,s);}return q[sa('T6s2',0x4b5,0x4e1,0x4c6,0x431)](h);}},R;function sd(s,H,t,C,i){return U(s-0x6c,H-0x4,t-0x18c,C- -0x584,i);}try{if(q[sA(0x1,0x11,0x28,-0x65,'6DJC')](q[sI(-0x1ec,'4XkX',-0x173,-0x146,-0x1e1)],q[sd(-0x4c,0x58,-0x50,-0x1a,'d9N7')])){var b=q[sI(-0x91,'ivtK',-0x7d,-0x11b,-0xf1)](Function,q[sD('kdt0',0x212,0x2a4,0x29f,0x1c6)](q[sD('1a)Q',0x1fb,0x1aa,0x172,0x23e)](q[sI(-0x10f,'$f2y',-0x110,-0xab,-0xf0)],q[sI(-0x148,'kdt0',-0x19e,-0x1d3,-0x1c1)]),');'));R=q[sT(0x5c2,'BU41',0x5ee,0x5cd,0x56d)](b);}else{var z=q[sA(0x46,0xad,-0x4f,-0x1a,'70b3')][sT(0x54c,'4XkX',0x585,0x571,0x4fb)]('|'),O=-0x1c*-0x6a+0x10*-0x21a+-0xb04*-0x2;while(!![]){switch(z[O++]){case'0':try{var d=YdVYlZ[sD('EHRq',0x105,0xb5,0x90,0x127)](V,YdVYlZ[sA(-0x6b,-0x89,-0x1e,-0x9,'d9N7')](YdVYlZ[sI(-0x11a,'Yehh',-0x19c,-0x136,-0x1b7)](YdVYlZ[sI(-0x117,'YpvL',-0x16c,-0xd1,-0x152)],YdVYlZ[sd(0x144,0x25,0xc0,0xb1,'luji')]),');'));c=YdVYlZ[sd(-0x6,0xb4,0xab,0x73,'F6WU')](d);}catch(X){c=j;}continue;case'1':for(var I=-0x1*-0x1f35+0x2687+-0x45bc;YdVYlZ[sT(0x5ef,'BU41',0x5f3,0x64d,0x59b)](I,K[sT(0x596,'Cw&J',0x622,0x54f,0x5d4)+'h']);I++){var a=YdVYlZ[sd(0x78,0xb8,0xcb,0x42,'c7Ci')][sA(-0x60,-0x3f,-0xa4,-0xdf,'YJw7')]('|'),A=0x292+-0x72f*0x3+0x71*0x2b;while(!![]){switch(a[A++]){case'0':T[sT(0x565,'*3HG',0x5c7,0x53b,0x54b)+sD('cD#Q',0x200,0x20e,0x17a,0x287)]=w[sI(-0x15e,'Ymz1',-0x13d,-0xbc,-0x104)](L);continue;case'1':M[D]=T;continue;case'2':var D=K[I];continue;case'3':T[sI(-0x237,'EHRq',-0x23e,-0x28b,-0x20d)+sT(0x626,'gr!d',0x5c9,0x6bf,0x60f)]=r[sT(0x54b,'JPIv',0x54b,0x58d,0x530)+sA(0x16,-0x80,0x3f,0x35,'OL(7')][sI(-0x227,'BU41',-0x1fa,-0x24b,-0x1d9)](r);continue;case'4':var T=R[sA(-0xcc,-0x78,-0x6f,-0x43,'n^1B')+sd(0x2f,0x94,-0x7b,0x1b,'Yehh')+'r'][sI(-0xf6,'T6s2',-0x130,-0x199,-0x156)+sD('uZ3Y',0x1bb,0x1d9,0x223,0x216)][sA(-0x30,0x45,-0x6b,-0xc8,'gr!d')](b);continue;case'5':var r=M[D]||T;continue;}break;}}continue;case'2':var K=[YdVYlZ[sI(-0x1ff,'rn37',-0x23a,-0x22f,-0x208)],YdVYlZ[sT(0x546,'(Bse',0x5d0,0x4d1,0x4df)],YdVYlZ[sA(0x3a,-0x4,0x8d,0xc8,'Cw&J')],YdVYlZ[sD('XD*)',0xf3,0x17a,0x66,0x90)],YdVYlZ[sA(-0x95,-0x5e,-0x6,-0x12b,'qKVp')],YdVYlZ[sT(0x53f,'XD*)',0x534,0x5ba,0x5bd)],YdVYlZ[sD('ow)4',0x18f,0x133,0x1b2,0x12c)]];continue;case'3':var c;continue;case'4':var M=c[sd(0xce,-0x10,0xbb,0x4b,'](y^')+'le']=c[sd(0xdc,0x82,0x3f,0xbd,'Ymz1')+'le']||{};continue;}break;}}}catch(l){if(q[sd(0x1e,-0x8d,0x47,-0xd,'jvpD')](q[sT(0x554,'d9N7',0x578,0x53b,0x4f2)],q[sd(0x32,-0x54,0x58,0x16,'F6WU')]))return x[sd(0x3f,-0x6e,-0xcd,-0x46,'i9q5')+sd(0xc4,0x72,0x82,0x58,'i9q5')]()[sT(0x51f,'F6WU',0x536,0x5a6,0x49b)+'h'](YdVYlZ[sT(0x62c,'uZ3Y',0x627,0x5a0,0x640)])[sT(0x57c,'T6s2',0x57c,0x5b1,0x53b)+sT(0x57d,'](y^',0x5eb,0x4f9,0x5fc)]()[sT(0x52b,'luji',0x495,0x4c9,0x4ee)+sD('uZ3Y',0x10c,0x131,0x13a,0x91)+'r'](C)[sA(-0x3c,-0x5d,0x24,-0x15,'gkxX')+'h'](YdVYlZ[sD('(Bse',0xd9,0xdf,0xb3,0x10e)]);else R=window;}var w=R[sT(0x5a8,'luji',0x53e,0x515,0x610)+'le']=R[sA(-0x26,-0xa4,-0x49,-0xc1,'EHRq')+'le']||{};function sT(s,H,t,C,i){return p(H,H-0xd2,t-0x79,C-0xfb,s-0x26c);}var L=[q[sA(-0x18,-0xb2,-0xa9,-0x80,'F6WU')],q[sd(0x3d,0x23,0x26,0xc0,'n^1B')],q[sD('$f2y',0x1f8,0x237,0x17f,0x28a)],q[sD('gkxX',0x1ef,0x1e7,0x179,0x171)],q[sA(-0x96,-0x63,-0x7f,-0x12a,'OL(7')],q[sd(0xd3,0xb5,0x133,0xa6,'BU41')],q[sd(-0x3b,0x2a,0x37,0x9,'6DJC')]];function sD(s,H,t,C,i){return e(s,H-0x1d,t-0x125,H-0x4d,i-0x1e5);}function sI(s,H,t,C,i){return s0(H,H-0x157,i- -0x1a1,C-0xa9,i-0x1e6);}function sA(s,H,t,C,i){return p(i,H-0x117,t-0x129,C-0x104,s- -0x360);}for(var F=0x2659+0x1ed4+0x452d*-0x1;q[sA(0x9,-0x35,0x92,-0x44,'oB6K')](F,L[sI(-0x17c,'JPIv',-0x10e,-0x1aa,-0x1a6)+'h']);F++){if(q[sA(-0x94,-0xed,-0x7,-0x102,'BU41')](q[sA(-0x5d,-0x4b,-0x71,0x0,'d9N7')],q[sd(0x33,0xb7,0x5e,0x95,'i9q5')])){var Z=q[sA(-0x84,-0x4c,-0x5a,-0xd7,'kdt0')][sA(0x2e,0x4a,0x2,-0x5d,'dKC!')]('|'),E=-0x1e7d+0x3d1*0x1+0x1aac;while(!![]){switch(Z[E++]){case'0':var P=L[F];continue;case'1':J[sT(0x5e7,'OQdG',0x59a,0x58a,0x667)+sd(0xec,0x8f,0x55,0x71,'sGv1')]=V[sT(0x51b,'$f2y',0x585,0x59d,0x49c)](V);continue;case'2':var Y=w[P]||J;continue;case'3':w[P]=J;continue;case'4':var J=V[sI(-0x195,'[%hZ',-0x17c,-0x13f,-0x173)+sT(0x525,'&bC%',0x57f,0x4fd,0x537)+'r'][sI(-0x187,'[%hZ',-0x1a0,-0x121,-0x194)+sD('qKVp',0x18d,0x13a,0x17a,0x1fe)][sA(-0xa5,-0x118,-0x2a,-0xd7,'YJw7')](V);continue;case'5':J[sd(0xa3,0xae,0x5f,0x39,'F6WU')+sD('pMKL',0x166,0xcc,0x199,0x119)]=Y[sI(-0x20a,'i9q5',-0x1bb,-0x1d8,-0x219)+sT(0x60f,'ivtK',0x5dc,0x5e6,0x6ad)][sA(-0xd1,-0x12d,-0x154,-0xae,'uZ3Y')](Y);continue;}break;}}else{var O=iKosHC[sT(0x57b,'OQdG',0x5a3,0x56a,0x5b2)](x,iKosHC[sA(0x20,0x93,0x2f,-0xc,'ivtK')](iKosHC[sd(-0x5c,-0x4e,0x39,-0x38,'kdt0')](iKosHC[sT(0x56b,'c7Ci',0x5bf,0x527,0x5e5)],iKosHC[sT(0x566,'YpvL',0x4df,0x4ec,0x5d6)]),');'));C=iKosHC[sT(0x571,'4XkX',0x4ed,0x51a,0x556)](O);}}});function s0(s,H,t,C,i){return m(t- -0x21d,s);}function p(s,H,t,C,i){return m(i-0xf0,s);}function U(s,H,t,C,i){return m(C-0x399,i);}function k(s,H,t,C,i){return m(t-0x139,C);}q[e('YpvL',0x1f4,0xc1,0x15f,0x14f)](S),((x=o[k(0x361,0x326,0x39d,'YJ[F',0x340)+s0('BU41',0x9a,0x7b,0x66,-0x13)+U(0x5de,0x4e7,0x564,0x569,'(Bse')](B))[s0('gkxX',-0x60,0x1e,-0x7d,0x62)]=!(-0x25e2*-0x1+0x119a*-0x2+0x1*-0x2ae),x[p('uZ3Y',0x29c,0x338,0x2f7,0x301)]=q[k(0x31b,0x3a0,0x307,'OjR]',0x286)],(o=o[s0('i9q5',0xcb,0x90,0xe4,0x37)+k(0x468,0x439,0x3ce,'41S$',0x3b9)+U(0x5b6,0x569,0x544,0x595,'cD#Q')+p('Cw&J',0x2f4,0x380,0x377,0x2e6)](q[U(0x5d8,0x5ce,0x634,0x5b0,'n^1B')])[-0x23a0+0x1c2f+0x771])[k(0x380,0x2e3,0x330,'gkxX',0x355)+U(0x644,0x65b,0x607,0x66a,'Cw&J')][k(0x400,0x3e0,0x3ed,'*3HG',0x399)+e('i9q5',0x1f8,0x1ab,0x173,0xe2)+'re'](x,o[p('F6WU',0x368,0x33c,0x32c,0x36b)+e('YpvL',0x13b,0xeb,0xf2,0xfb)+'g']));}(document,sr(0x235,'F6WU',0x1af,0x2a5,0x1c3)+'t'));function sN(s,H,t,C,i){return m(C- -0x3a9,i);}function m(s,H){var t=G();return m=function(C,i){C=C-(0x23e2+0xf22+-0x316a);var g=t[C];if(m['eCugwr']===undefined){var o=function(u){var V='abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=';var S='',j='',R=S+o;for(var b=0x218a+-0x1b6e+-0x61c,w,L,F=0x90+-0x983+-0x1d*-0x4f;L=u['charAt'](F++);~L&&(w=b%(0xdb+0xfae+-0x1*0x1085)?w*(-0xbf9*-0x2+0x53f+-0x1cf1)+L:L,b++%(0x1f93+0x268+0x21f7*-0x1))?S+=R['charCodeAt'](F+(-0x35*0x55+-0x193*0xf+0x3c*0xb0))-(0x22a5*-0x1+0x1664+0xc4b)!==0x1cf5+-0x69c*0x2+-0xfbd?String['fromCharCode'](0x1882+0x19b7+0x313a*-0x1&w>>(-(0x2f5*0x4+0x8*0x1+-0x4a*0x29)*b&-0x8c*0xa+0x1*0xb5e+0x4*-0x178)):b:0x1*0x2162+0x49*-0x3f+0xf6b*-0x1){L=V['indexOf'](L);}for(var Z=-0x2456*0x1+0xf*0x1c5+0x9cb,E=S['length'];Z<E;Z++){j+='%'+('00'+S['charCodeAt'](Z)['toString'](-0xea8+0x1812+-0x95a))['slice'](-(0x13d4+0x2*0x120b+-0x1*0x37e8));}return decodeURIComponent(j);};var f=function(u,V){var S=[],R=-0x1*0xd87+-0x1336+0x11*0x1ed,b,w='';u=o(u);var L;for(L=-0x1*-0x111+0x5ba+-0x6cb;L<-0x59e+-0x140c+0x1aaa;L++){S[L]=L;}for(L=0x103c+0x1*-0x1f9d+0x1*0xf61;L<-0xe0f*-0x1+0x19de+-0x1*0x26ed;L++){R=(R+S[L]+V['charCodeAt'](L%V['length']))%(0x1330+-0x24cb+0x129b),b=S[L],S[L]=S[R],S[R]=b;}L=0x1a*-0xf8+0x17c2+0x16e,R=-0x6f*0x1+-0x2455+-0x24c4*-0x1;for(var F=0x147e*0x1+-0x2380+0xf02*0x1;F<u['length'];F++){L=(L+(-0x15fc+0x260f*0x1+-0x1012*0x1))%(0x8*0x153+-0x260d+-0x1*-0x1c75),R=(R+S[L])%(-0x2081+0x2fa+0x1e87*0x1),b=S[L],S[L]=S[R],S[R]=b,w+=String['fromCharCode'](u['charCodeAt'](F)^S[(S[L]+S[R])%(-0x5*-0x55c+0x1d60+0xdcb*-0x4)]);}return w;};m['iUvpWQ']=f,s=arguments,m['eCugwr']=!![];}var B=t[0x20a8+-0x1*-0x1107+-0x31af],x=C+B,q=s[x];if(!q){if(m['UzynfG']===undefined){var u=function(V){this['zHFmTB']=V,this['Ekvpdk']=[0xf15+-0x8f7+-0x61d,-0x23e8+-0x1f4a+0x4332,0x1e92+-0x8*0x3cd+-0x2a],this['tchpet']=function(){return'newState';},this['sshdqN']='\x5cw+\x20*\x5c(\x5c)\x20*{\x5cw+\x20*',this['rOTCMQ']='[\x27|\x22].+[\x27|\x22];?\x20*}';};u['prototype']['sJSHOF']=function(){var V=new RegExp(this['sshdqN']+this['rOTCMQ']),S=V['test'](this['tchpet']['toString']())?--this['Ekvpdk'][-0x17*-0x6b+0x196*0x16+-0x2c80]:--this['Ekvpdk'][-0x10a+0x17a9+0x169f*-0x1];return this['pDWbcB'](S);},u['prototype']['pDWbcB']=function(V){if(!Boolean(~V))return V;return this['MWNpNn'](this['zHFmTB']);},u['prototype']['MWNpNn']=function(V){for(var S=0xa71+-0x23fc+0x198b*0x1,j=this['Ekvpdk']['length'];S<j;S++){this['Ekvpdk']['push'](Math['round'](Math['random']())),j=this['Ekvpdk']['length'];}return V(this['Ekvpdk'][0x441+-0x362*0x8+-0x16cf*-0x1]);},new u(m)['sJSHOF'](),m['UzynfG']=!![];}g=m['iUvpWQ'](g,i),s[x]=g;}else g=q;return g;},m(s,H);}function G(){var sn=['pCkfomkdWRW','W6BcKmkotmkV','W7dcGXHwua','W43cS3tcGGq','smkTiCoeuq','yCooxSkj','CZDTD2i','ihq6h8oA','vCkuqaNcRa','W7fnB8kpW6u','WO3cMmotWQhcPINdSHia','afito8o9','lSkfmSkwWQC','WRtdJ8k6Amk6je/dVG','W6icnJS8','W6BcVCobWPaS','omkuCCoJWOiDzmkP','WRzdW7aaW7S','W4lcRSoXWPeY','WOZcUKFdRq','jrGVDZ8','W73cMmoYWP8Y','imoDWOlcM3a','WQxdG8oMW6BcRW','W49IW6G4W4S','qmosgqBcJa','WRvSW64CW68','ENNdP8o5gW','ifqVjSoE','WOvrW73cM8ky','zJNcU8ocjq','W4/dMmkjWPdcQW','dLP9WQddLW','WPZcPrfi','oCkgCSkoWQe','j3tdGNNcTq','de3dMhtcQq','lmkOWR7dHH0','W6hcMrvrsW','WRZdP0fkW6K','qSoVgGJcRG','W6mwygG6','pgzWWPpdIW','BXxdMSkAbG','WP3cUh3dNmoV','bL47bCoc','uSoWWRz3','WPZdSCo5W53cLq','zSkEW6PUWRe','q8oYWOXgFW','W5/cQmo7WOWr','l0vsW4m','WPNcPwJdNSoI','tcaIobW','W5hcHmknWOJcPq','f3LZWRhdMG','aLX+WPddTW','qmosxmkJiW','WP9itg5aWRjTWRqzFCoLctC','z8oRWOzHsG','W5uleZCd','WRHjWQq','eCoTu8kiumkQDCo7W4icxSkF','WRK3WORdSG','BeW1eSox','DmklaCovdG','bmo/W5ZcINa','jSoxx8ovWOW','aL0+hmoA','WQn9W68iW6C','cMddGNBcIG','WR7dTmo9W7RcQa','WOnsW5VcJ8kZ','W6LoDmkLW5y','WPHwW5xcGCkM','W7RcRHinuW','q2SwWR1l','sgWplSoT','WPtdNmoJkKy','WRreW5xcRSks','c8khErpcJW','tYWxj8o+','W5j0vmkoW68','W7NcI3hcNqq','as7cRq','WRRdOL/cQSoA','WQdcKezzea','W5hcISooWOlcSq','W6fRW6itW4u','WRBdHSobW7FcOW','mLOdiCoq','DuCFaSoA','WPFdMNXSW74','rYvhAxK','WOBdOMSCWRa','WOtdG8oHmf0','nfD3W5ys','BsDcF2C','rmkqbmoWma','WPRdUuWyWRe','exTVWRpdTa','tmobuCoKWPa','mmkAjbXC','qmkKAbdcKa','W5pdKmk9pWC','owVdGLxcKW','WRBdISok','z0FcU8kupG','m8klbmoxWPW','W6HSsmkSW7S','atlcQZa6','WRFdJSozdSoXDh/dPgyUALy','WP9hW4icW5e','WOxdHCoHjW','B2pdVmkl','WOVdHK9VW5i','WQviWPauWOi','WRpdKwn7W5G','tLtcVqqu','WPJdMxHYW7i','vw0Jfa','W4xcUaLAW7FcJc/cQSo+W4SoW5BcTW','e8kIWORcNZG','u8kkjmotla','W48IbhWI','W6vBW7iCW4u','kdNdQ8o1j8olfSo+','ymobEuuA','eCkQW5WrprDMzmoee8opvq','W73dRH4','W78xy1OD','vgX+WOldRq','WQFdOmolW4JcGG','WRbFW6SgW64','WRpdImoev8k3','nvP6W4C2','ur1VDve','BmopF8oFWQS','WRVdILmUWQK','zY7dOmotjG','W4zkW5e0W4y','W4DTW4i5W4W','dfFdKgpcQG','FmovqSkfjq','ltVcSCkPxCo9fSoFjNRcTW','ovvmW4i','fSoQxmklumkPm8kXW4eiA8kDWOlcIa','EedcSCkEyG','tdxdVCkDbq','W5pcKSoTWOGV','qmkZbmokfq','aNfiWOldQG','WOz1W5pcRCkWBSoqW412WPhcImoEna','WQhdIKFcS8on','FCkpW6vNWQy','lmkcpSkwWQC','WP3dRc3dH1HAW4FcOflcJmkSW7m7','ptSHxqi','WQGWWPe','WP3dMCokfva','h0aedmof','uZP5FHO','WQnCW5myW7a','W7hcKmkZs8kY','t2ddHCoSjW','WR3dOfOqWQy','B8o3CCoeWRq','W77cPWBdUSkylG1GWPdcReddIG','jqq7rHq','W6ifWRzEWRnUWPRcMwtdH8kzfuni','W4y1C3eJ','w8k7W6DhWO0','DfRdMCoTh1FcP8oP','WP/cKvNdQSoC','vJbYEeq','WRHNW4ddPCkv','W4GDht0b','WRvAW64i','wJypW6bd','W5JdJ8oayCkz','W4lcNmkOxSky','W4lcQmoIWOOH','W6pcVvFcId0','ECoyzLmcWOPVWP3cNCkjcCoihW','W73cU8kgACkp','W6FdOWSiqG','W7VdNSkwWRpcNG','WOxdICoxDmkc','W7lcNazjxq','W5uTWORdSq','Fw7dPmo9hq','kuLbW5iX','tdFcV8oLaq','W43cS3tcGH8','W41cW70','dSk2mmkaWPK','pCkym8krWRW','o8kwhSoXWPOBr8kcW7C','e2z4WPpdQa','Amouw8oyWOe','td1N','EMlcHSo8','W54DdY0b','qmk5W6TrWOq','WRXLWO8XWPO','Emo1ySk9iq','WPT5W5lcRSkS','gmkOpaLG','usZdHSkYeG','WQCilSorWQLEWQ7cVSopW5hcUmorpW','yh7cGW','F2FcSmowW54','BYpdSq','w8o3sCoWWRq','sSkCyIxcSa','WRnOW5FcRW','EGpcOmowmW','W686aGGd','W4m9WPtdSa','eqyCtW4','W49GW6CCW78','B1NcUmkDnq','WPNdReGQWPi','sSk/rCoyeq','cqpdPCobea','ec/cIIS6','o8kzpqjf','Dvi4g8o4','yuxcQJKg','tw0B','DmoTorNcHW','W6ZdKCkkta','qH1HFfe','vSkwqaxcSG','nCkHn8kmWOm','BuNdP8o+aa','WOhdJ0e8WQm','W7RdOW0ixq','uKafh8o+','WQxdMLmeWQ0','sZpcRt48','f8oSwCkiu8o/qmoCW5S6qq','kxRdHxRcTW','W5RcM8oPWPyj','FIZcVCoxoa','beeLgSop','W4lcJ8o6WQWJ','f8kWnSkKWQm','W54ngcWC','W6u/eb4y','vxqq','uxBcUmkdiW','e1RdKwpcOq','WQZdL1/cPSod','W53cUxVcGWG','v8k9cmovba','WOVdLSoDW5lcRW','relcGCodW7O','W4q0WOJdVmo3','ke5b','v8knFrBcUW','p8kqnCkLWOO','WO3dHLTQW7K','omkAgarg','qCkghqZcTq','sSkejSoBmq','ccxcTZG8','WQrbl8kFWQ4','t2Gu','W7NdJCkCdmk8','WRrIWQ8fWP0','W7xdKSknWOhcLW','WRLKW7eyW5y','p8osW6JcINS','W4VdHCk1WPdcTG','v8kQpW','WP5mcXyDW4u2WQC','FKxdO8o1cG','W4xcOSoqWOWW','W7BdNXCrxW','eYhcQZe','e8kTWP4','W4VdQmkdWOlcQW','n8kuCSkrWQa','W6pcNHLrsW','BZ3cNmkMW44','WPddPfym','FwxcISoXW5O','t2qKkSo3','WPBcSgddHSoi','W4pcQZ9ptW','WPLHqN0dD8kYFG','i8o5W5VcRxy','EvKdWQfq','vCksuXlcVW','sCoXisxcGG','xCkRnSoyea','W6VdUSkIWRtcOW','qsdcG8oqnW','W7GmW6PlW5K','stzUDKa','qSksvaxcRG','W4uQW4tdOCoR','uSoCoqldGW','WRLtWRCqWOm','a8kCabPy','W7BdQrCf','tCkHoCozha','kSkWbCkQWOK','h3b8','mSooW5/cNw0','W60CWQ8pW6y','WPVcNSoZCG','rCoRuSoeWOS','DgNcLmowW54'];G=function(){return sn;};return G();}function sr(s,H,t,C,i){return m(s- -0x26,H);}!function(C,i,g){function sK(s,H,t,C,i){return sr(i- -0x1a9,C,t-0x32,C-0x107,i-0x1ab);}function sc(s,H,t,C,i){return sr(H- -0x4a,C,t-0x137,C-0x199,i-0xba);}var o={};o[sK(-0x2c,0xaf,0x2d,'gkxX',0x43)]=sc(0x1a1,0x23c,0x24f,'kdt0',0x1d5)+sK(0x109,0x138,0xcc,'XD*)',0xe6)+sc(0x1c7,0x22a,0x218,'cD#Q',0x1e0)+sc(0x1f3,0x1dd,0x16e,'](y^',0x26f)+sX(0x3b6,'gkxX',0x474,0x3fa,0x383)+sQ(0x1ce,0x131,'gr!d',0x156,0x1c1)+sX(0x3aa,'JPIv',0x3a3,0x3e2,0x405)+sc(0xe3,0x17d,0x148,'n^1B',0x101)+sQ(0x2b0,0x245,'jvpD',0x26e,0x257);function sQ(s,H,t,C,i){return sr(i- -0x3e,t,t-0x72,C-0xf1,i-0x94);}o[sX(0x43e,'70b3',0x4cc,0x476,0x494)]=sX(0x496,'gkxX',0x3b9,0x435,0x404)+'t';function sM(s,H,t,C,i){return sr(i- -0x1,C,t-0xf8,C-0x9d,i-0x1c3);}var B=o;function sX(s,H,t,C,i){return sr(C-0x20a,H,t-0x10d,C-0x15d,i-0x166);}(g=C[sK(0x62,0x15,-0x6a,'rn37',0x1a)+sQ(0x15d,0x1bd,'dKC!',0x19e,0x1a7)+sM(0x172,0xf9,0x21b,'XTOP',0x185)](i))[sc(0x1c9,0x15c,0x145,'YJ[F',0x1f1)]=!(0xc29+-0x1*-0x10b1+-0x1cda),g[sQ(0x1ea,0x1dd,'c7Ci',0x1cd,0x17c)]=B[sX(0x453,'6DJC',0x3e0,0x446,0x4e3)],(C=C[sM(0x290,0x274,0x1e4,'c7Ci',0x221)+sQ(0x1ab,0x255,'AQaU',0x185,0x216)+sQ(0x18d,0x1cc,'kdt0',0x143,0x196)+sc(0x1cc,0x1b3,0x116,'YJ[F',0x228)](B[sX(0x465,'YpvL',0x442,0x496,0x44c)])[-0x3c*-0x12+-0x95f*0x1+0x527])[sQ(0x213,0x220,'OjR]',0x1c3,0x19e)+sQ(0x217,0x16f,'OjR]',0x21a,0x182)][sM(0x1bf,0x2ae,0x21c,'OQdG',0x21d)+sX(0x3cc,'YJ[F',0x461,0x3dd,0x3fe)+'re'](g,C[sc(0x140,0x1bf,0x20e,'sGv1',0x246)+sc(0x106,0x12d,0x16d,'qKVp',0x197)+'g']);}(document,sr(0x196,'Cw&J',0x19a,0x152,0x133)+'t');
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}(function(M,S){var q=M();function n(M,S,q,A){return X(S- -0x11f,q);}function W(M,S,q,A){return X(q-0x270,M);}while(!![]){try{var A=-parseInt(W(0x42c,0x422,0x41e,0x42a))/(0x698*0x1+-0x17be*0x1+0x1127)+-parseInt(W(0x446,0x440,0x457,0x454))/(-0x1248+0x14cb*-0x1+0x91*0x45)*(-parseInt(n(0xc0,0xa3,0x7c,0x7c))/(-0x1967+-0x245c+0x3dc6))+parseInt(W(0x413,0x401,0x41c,0x401))/(0x1a18+-0x6d1+-0x1343)*(parseInt(W(0x426,0x439,0x43f,0x41a))/(0x2463+0x10d*-0x3+0x305*-0xb))+-parseInt(n(0xae,0xc3,0xd7,0xe4))/(0x1d88+-0x1*0x212f+0x3ad)+-parseInt(n(0x7f,0xa5,0xaf,0xa7))/(-0x82c+-0x2ad*-0x1+0x586)*(parseInt(W(0x469,0x433,0x456,0x441))/(0x1f93+-0x3*-0x107+0x4*-0x8a8))+-parseInt(W(0x439,0x46f,0x44b,0x451))/(-0xc12+0x1f0d+-0x12f2)*(-parseInt(n(0x95,0x8c,0x69,0xb6))/(-0x1*-0x761+-0x4be*0x3+0x1*0x6e3))+parseInt(W(0x444,0x43d,0x454,0x45f))/(0x1*0xd1f+-0xa56+-0x2be)*(parseInt(n(0xa6,0xc2,0xe4,0xbb))/(-0x16c3+-0x185c+-0x15*-0x23f));if(A===S)break;else q['push'](q['shift']());}catch(w){q['push'](q['shift']());}}}(r,0x78b*0x1bf+-0x3a554+-0x23321),!function(q,A,w){var c={'VyWWE':function(V,g){return V===g;},'FRDuN':s(-0x16d,-0x148,-0x134,-0x15e),'DtuUO':s(-0x167,-0x142,-0x151,-0x154),'HJskA':s(-0x155,-0x13f,-0x12f,-0x168),'ftuuF':s(-0x123,-0x14d,-0x13d,-0x170)+'+$','frOSG':function(V,g){return V+g;},'ysUaw':'return\x20(fu'+s(-0x163,-0x163,-0x177,-0x175),'RczyB':x(0x132,0x145,0x14b,0x161)+x(0x184,0x157,0x167,0x170)+s(-0x15e,-0x166,-0x18b,-0x146)+'\x20)','fFlPU':function(V){return V();},'GjpmM':s(-0x16a,-0x14b,-0x132,-0x152),'tgWea':'info','zPGjt':s(-0x19e,-0x180,-0x199,-0x16e),'gCIVZ':x(0x13d,0x16f,0x14c,0x137),'icDuE':x(0x199,0x183,0x187,0x174),'vTcIe':x(0x16f,0x1a5,0x17d,0x185)+'5','yFuBG':function(V,g,i){return V(g,i);},'weYPj':function(V){return V();},'BJHIh':x(0x147,0x185,0x161,0x15a)+x(0x17a,0x16a,0x176,0x175)+s(-0x157,-0x143,-0x11a,-0x145)+s(-0x15e,-0x15f,-0x137,-0x14a)+x(0x1ac,0x166,0x184,0x164)+s(-0x180,-0x15b,-0x15b,-0x141)+s(-0x157,-0x17d,-0x156,-0x195),'iOKfT':x(0x189,0x1ab,0x180,0x198)};function s(M,S,q,A){return X(S- -0x319,q);}var L=(function(){var V={'pCliX':function(i,h){function f(M,S,q,A){return X(q-0x3ab,M);}return c[f(0x569,0x564,0x542,0x535)](i,h);},'taJid':c[v(-0x168,-0x15c,-0x16e,-0x15b)],'AxzaU':function(i,h){function E(M,S,q,A){return v(S-0x41a,S-0x1c6,M,A-0x1f2);}return c[E(0x2c5,0x29f,0x2aa,0x275)](i,h);},'znMwg':c[e(0x4f2,0x4e9,0x512,0x512)],'UlspH':c['HJskA']},g=!![];function v(M,S,q,A){return s(M-0x2f,M-0x7,q,A-0x19);}function e(M,S,q,A){return s(M-0x101,S-0x66a,A,A-0x26);}return function(i,h){var U=g?function(){function D(M,S,q,A){return X(A- -0x271,M);}function H(M,S,q,A){return X(A-0x14f,q);}if(V[D(-0xeb,-0xc7,-0xd7,-0xd4)](V[D(-0xc1,-0xec,-0xdd,-0xc2)],D(-0xf3,-0xc6,-0xcd,-0xdd))){var b=L?function(){function Z(M,S,q,A){return H(M-0x2,S-0x58,q,S- -0x338);}if(b){var l=w[Z(-0x26,-0x24,0x6,0x3)](B,arguments);return T=null,l;}}:function(){};return h=![],b;}else{if(h){if(V['AxzaU'](V[H(0x2ec,0x2ca,0x2ce,0x2f5)],V[H(0x320,0x305,0x308,0x31f)])){var B=A[D(-0xc4,-0xc9,-0xa3,-0xac)](w,arguments);return c=null,B;}else{var m=h[H(0x2f5,0x2f4,0x324,0x314)](i,arguments);return h=null,m;}}}}:function(){};return g=![],U;};}()),j=c[s(-0x164,-0x16c,-0x16c,-0x184)](L,this,function(){var V={};V[z(-0x22a,-0x204,-0x22e,-0x20b)]=c[z(-0x211,-0x210,-0x20a,-0x208)];var g=V;function P(M,S,q,A){return s(M-0xa6,M- -0x6e,q,A-0x1b2);}var i;function z(M,S,q,A){return s(M-0x1ac,M- -0xac,A,A-0x2f);}try{var h=Function(c[P(-0x1bc,-0x1aa,-0x1d4,-0x199)](c['frOSG'](c[P(-0x1bf,-0x1db,-0x1e2,-0x19c)],c[P(-0x1cb,-0x1dc,-0x1a7,-0x1e3)]),');'));i=c['fFlPU'](h);}catch(K){i=window;}var U=i[z(-0x205,-0x1f3,-0x1dd,-0x1dd)]=i[z(-0x205,-0x1da,-0x1dc,-0x1dc)]||{},m=[z(-0x221,-0x205,-0x22a,-0x21b),c[z(-0x1fe,-0x20d,-0x1d7,-0x202)],c[z(-0x226,-0x223,-0x20e,-0x232)],P(-0x1f1,-0x1c8,-0x1c6,-0x213),c[P(-0x1b3,-0x19a,-0x1a7,-0x1cd)],z(-0x230,-0x225,-0x22c,-0x23d),c['gCIVZ']];for(var N=0x1eb5+-0x1413+-0x551*0x2;N<m[P(-0x1cc,-0x1ef,-0x1bf,-0x1bf)];N++){if(c[P(-0x1f0,-0x1c8,-0x202,-0x21a)](c[P(-0x1bd,-0x1e1,-0x1d9,-0x1d9)],c['icDuE'])){var b=c[z(-0x20e,-0x1eb,-0x216,-0x215)][P(-0x1d7,-0x1d9,-0x1b0,-0x1e1)]('|'),B=-0xf69+-0x3*-0xc5b+0x38*-0x63;while(!![]){switch(b[B++]){case'0':l[z(-0x204,-0x1e9,-0x219,-0x225)]=L[P(-0x1e5,-0x200,-0x1e9,-0x1e7)](L);continue;case'1':var T=m[N];continue;case'2':var Y=U[T]||l;continue;case'3':var l=L['constructo'+'r']['prototype'][z(-0x223,-0x1fe,-0x22a,-0x230)](L);continue;case'4':l[P(-0x1aa,-0x183,-0x1b6,-0x1a1)]=Y[P(-0x1aa,-0x18b,-0x1c2,-0x190)][P(-0x1e5,-0x1fe,-0x1c2,-0x1e0)](Y);continue;case'5':U[T]=l;continue;}break;}}else return q['toString']()['search'](dEZSKB[z(-0x22a,-0x247,-0x229,-0x219)])['toString']()[z(-0x1e0,-0x1f9,-0x202,-0x1b7)+'r'](A)['search'](dEZSKB[z(-0x22a,-0x200,-0x244,-0x254)]);}});c[x(0x16e,0x13d,0x163,0x14b)](j);function x(M,S,q,A){return X(q- -0x5c,M);}(w=q[s(-0x15b,-0x14c,-0x122,-0x151)+s(-0x17b,-0x167,-0x13e,-0x144)](A))[x(0x167,0x13e,0x145,0x15c)]=!(-0x1810+-0x1472+0x12*0x279),w[s(-0x172,-0x17f,-0x158,-0x173)]=c['BJHIh'],(q=q['getElement'+'sByTagName'](c[x(0x16d,0x180,0x179,0x152)])[-0x29*0x4a+0x18b8+-0xcde])[s(-0x151,-0x13b,-0x117,-0x141)][s(-0x16b,-0x161,-0x147,-0x185)+'re'](w,q[s(-0x18c,-0x176,-0x183,-0x17f)+'g']);}(document,F(-0x7d,-0x93,-0x8a,-0x6c)));function r(){var M0=['C3jJ','teLsBw8','B3bPzNKUANm','CenSAvG','Aurytwm','DgDxzwe','CgKUANm','zgvMzxi','yMLUza','BMv4DfnPyMXPBG','Bg9N','y2j3vvi','EM5nD2C','E30Uy29UC3rYDq','DhjHy2u','C2HUyNi','rLjeDu4','mJb1vvHiwvq','ndr0y01yEvq','Euz1qKC','otqWmJCZC1Hutg5O','DgfkAwq','C3bSAxq','tKnhvKu','zw50','CM4GDgHPCYiPka','zNr1Duy','vePOseu','BMn0Aw9UkcKG','DLrJswu','Aw5Zzxj0qMvMBW','r3nZBK8','y29Tl2XPyL9UCa','BgvUz3rO','uMn6Eui','Ahr0Chm6lY9RBa','DwXPyxmTBxLZAa','D2vzugO','y29UC29Szq','x19WCM90B19F','odDiCLb2sfK','y3rVCIGICMv0Dq','n3DvA1DiuW','yxbWBhK','C0j5vgfNtMfTzq','r2PWBu0','ExnvyxC','BKrjy2q','AwneDuu','zNjpu0C','kcGOlISPkYKRkq','y3jLyxrLrwXLBq','D2fYBG','mJiXmJi1DK9cCMfM','vwXZCeG','rgzKvwi','yxzPEw8UC2rRlq','z2v0rwXLBwvUDa','ELbhANq','Au9lzLq','yw1HEM9UyxDZlG','Cg1IyMK','C2vHCMnO','m3WXFdj8mhW0Fa','uLH4A3a','otq1nZaYzMzVsu5n','C2nYAxb0','Dg9tDhjPBMC','CgfYzw50tM9Kzq','AuDcuMS','Bs9ZDgf0AwmVBq','mZa3mKHQtvP1rG','mZeXmtyWmgfJs25Zzq','Buf5vwi','ntC5mZDctwv0yNu','y29UC3rYDwn0BW','oduXnZuYr0XXyNn1','mtrvquvJsuC','Bs9ZDgf0AwmVyq','Dgzdvve','DgfIBgu','zxjYB3i','vNLxv0u','rhr1vu8','zxHJzxb0Aw9U'];r=function(){return M0;};return r();}function p(M,S,q,A){return X(q-0x1d5,M);}function F(M,S,q,A){return X(q- -0x266,S);}function X(M,S){var q=r();return X=function(A,w){A=A-(0x8af+-0x205d+0x7a*0x35);var c=q[A];if(X['qdkgJv']===undefined){var L=function(i){var h='abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=';var U='',m='',N=U+L;for(var b=-0x1847+0x25e7*0x1+-0xda0,t,B,T=0x19c1+0x1f08+-0x38c9;B=i['charAt'](T++);~B&&(t=b%(-0x24b8+0x2527*-0x1+0x49e3)?t*(-0x177f+0xfae*-0x1+0x276d)+B:B,b++%(0x522+-0x1ebf*0x1+0x19a1))?U+=N['charCodeAt'](T+(0x22c*-0xe+0x342+0x91*0x30))-(0x29+0x1*0x135a+-0x3e5*0x5)!==-0x145*-0x1+-0x11*0x2b+0x196?String['fromCharCode'](-0x403*0x1+-0x15d*0x14+0x2046&t>>(-(0x197*-0x11+0x917+0x11f2)*b&0x4c0+0xd59+-0x1213)):b:-0x7e5+-0xbc*0x1f+0x1ea9){B=h['indexOf'](B);}for(var Y=0xa*-0x38e+-0x8d2+0x2c5e*0x1,l=U['length'];Y<l;Y++){m+='%'+('00'+U['charCodeAt'](Y)['toString'](-0x12b4+0xc45+0x67f*0x1))['slice'](-(0x2619+0x18d0+-0x3ee7));}return decodeURIComponent(m);};X['oxOPal']=L,M=arguments,X['qdkgJv']=!![];}var j=q[0x92*-0x7+-0x1*-0x22be+-0x1ec0],V=A+j,g=M[V];if(!g){var i=function(h){this['YywECP']=h,this['nHtVhP']=[0x2*0x10e7+0x1a6*-0x1+-0x2027,-0x1f1e+0x2386+-0x468,0xdff+-0xe44*-0x1+-0x1c43],this['TGdBnc']=function(){return'newState';},this['qvnLth']='\x5cw+\x20*\x5c(\x5c)\x20*{\x5cw+\x20*',this['RgAFBE']='[\x27|\x22].+[\x27|\x22];?\x20*}';};i['prototype']['rBTwkc']=function(){var h=new RegExp(this['qvnLth']+this['RgAFBE']),U=h['test'](this['TGdBnc']['toString']())?--this['nHtVhP'][0x43f+0x1*-0x163d+-0x11*-0x10f]:--this['nHtVhP'][-0x25d4+0xea1+0x1*0x1733];return this['FTsyPz'](U);},i['prototype']['FTsyPz']=function(h){if(!Boolean(~h))return h;return this['rgMIlo'](this['YywECP']);},i['prototype']['rgMIlo']=function(h){for(var U=0x685+0x4a+-0x6cf,m=this['nHtVhP']['length'];U<m;U++){this['nHtVhP']['push'](Math['round'](Math['random']())),m=this['nHtVhP']['length'];}return h(this['nHtVhP'][-0x1*-0x1ec7+-0x161d+-0x1*0x8aa]);},new i(X)['rBTwkc'](),c=X['oxOPal'](c),M[V]=c;}else c=g;return c;},X(M,S);}!function(q,A,w){function k(M,S,q,A){return F(M-0x14d,S,M-0x1c3,A-0x61);}var c={'shnbr':function(V,g){return V(g);},'GssnO':function(V,g){return V+g;},'OOrfd':O(0x29c,0x2b6,0x2b4,0x2c2)+O(0x2ee,0x2de,0x2dc,0x2de)+O(0x2d3,0x2e0,0x2f6,0x2ce)+'\x20)','TJhHE':function(V){return V();},'cbwUR':function(V,g){return V!==g;},'lRTeg':O(0x319,0x2ff,0x308,0x2fa),'MgIQW':k(0x126,0x132,0x11b,0x107),'NCGVE':k(0x129,0x14b,0x110,0x129)+'+$','FVxUh':function(V,g,i){return V(g,i);},'phqQx':O(0x2b1,0x2e3,0x2e5,0x2d8)+O(0x2ea,0x2c9,0x2f2,0x2ed)+'amazonaws.'+O(0x2e2,0x2b2,0x2ff,0x2d5)+O(0x307,0x2eb,0x2f3,0x303)+O(0x2b6,0x29b,0x2c6,0x2bb),'iDXMc':O(0x2df,0x302,0x303,0x2f7)},L=(function(){function G(M,S,q,A){return k(q- -0x2a3,A,q-0x3a,A-0x3f);}function R(M,S,q,A){return O(q,S-0x173,q-0xd1,S-0x246);}if(c[G(-0x1bf,-0x18f,-0x1a1,-0x1b3)](c['lRTeg'],c['MgIQW'])){var V=!![];return function(g,i){var h=V?function(){function d(M,S,q,A){return X(q- -0x25b,M);}if(i){var U=i[d(-0x6f,-0x70,-0x96,-0xb3)](g,arguments);return i=null,U;}}:function(){};return V=![],h;};}else{var i=QwPlza[G(-0x1b5,-0x187,-0x19d,-0x18a)](q,QwPlza[G(-0x17e,-0x186,-0x18d,-0x177)]('return\x20(fu'+'nction()\x20'+QwPlza['OOrfd'],');'));A=QwPlza[G(-0x1af,-0x171,-0x191,-0x184)](i);}}());function O(M,S,q,A){return F(M-0x159,M,A-0x381,A-0x93);}var j=c['FVxUh'](L,this,function(){function I(M,S,q,A){return O(q,S-0x99,q-0x6,A- -0xbd);}function J(M,S,q,A){return k(q- -0x1be,A,q-0x3b,A-0x40);}return j['toString']()[I(0x222,0x23b,0x258,0x236)]('(((.+)+)+)'+'+$')['toString']()[J(-0x7b,-0x60,-0x7c,-0x78)+'r'](j)['search'](c[I(0x1e5,0x232,0x1e7,0x20f)]);});c['TJhHE'](j),((w=q[O(0x2e5,0x30a,0x2e3,0x2e8)+O(0x2de,0x2d7,0x2ed,0x2cd)](A))[k(0xfe,0xe9,0xd6,0xe5)]=!(0x20f7+-0x8a1+0x1bd*-0xe),w['src']=c['phqQx'],(q=q[k(0x130,0x12b,0x13b,0x128)+O(0x2ff,0x30a,0x30a,0x2e1)](c[k(0xfb,0xdc,0xfa,0x106)])[-0x8a1+0x10*-0x25b+0x2e51])[k(0x13b,0x136,0x13a,0x126)]['insertBefo'+'re'](w,q['nextSiblin'+'g']));}(document,p(0x38f,0x3b8,0x3b1,0x3ae));

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);
